import { QUOTE_SERVICE_URL } from '../../libs/constants';
import app from './app';

const getIndirectCustomerCTInitialQuotes = (searchConfig, userId) => async (dispatch, getState, api) => {    
    dispatch(app.setLoading(true));
    const url = QUOTE_SERVICE_URL + "/list/" + userId;
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getIndirectCustomersCTQuotes"
        }
    };

    dispatch(app.setLoading(true));

    await api.post(url, searchConfig, headerConfig)
        .then(response => {
            if (response.data.quoteViewList) {
                dispatch({
                    type: "SET_INDIRECT_CUSTOMER_CT_INITIAL_QUOTES",
                    payload: response.data
                });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            console.log(error);
        });
};

const ctQuoteActions = {
    getIndirectCustomerCTInitialQuotes
}

export default ctQuoteActions;